// extracted by mini-css-extract-plugin
module.exports = {"section":"e_WW","list":"e_XW","ask":"e_YW","empty":"e_ZW"};